export enum AllocationType {
  PRIME,
  CROSS,
  COMPONENT,
  UNSPAWNEDCOMPONENT,
}

export namespace AllocationType {
  let elements = [
    AllocationType.PRIME,
    AllocationType.CROSS,
    AllocationType.COMPONENT,
    AllocationType.UNSPAWNEDCOMPONENT,
  ];
  let alias = "com.bcdfx.model.common.api.enums.AllocationType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
